import React, { useState } from 'react';
import { ImageLightbox } from '../../../../components/ImageLightbox/ImageLightbox';
import './FaqImage.scss';

interface FaqImageProps {
    src: string;
}

export const FaqImage = ({ src }: FaqImageProps) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <div className="faq-item-image-wrapper">
                <button
                    className="faq-image-expand-btn"
                    title="View full size"
                    onClick={(e) => { e.stopPropagation(); setIsOpen(true); }}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M3 3h6v2H5v4H3V3zm12 0h6v6h-2V5h-4V3zM3 13h2v4h4v2H3v-6zm16 4h-4v2h6v-6h-2v4z" />
                    </svg>
                </button>
                <img className="faq-item-image" src={src} alt="" />
            </div>

            {isOpen && (
                <ImageLightbox src={src} onClose={() => setIsOpen(false)} />
            )}
        </>
    );
};
